import { FComponent } from 'Components/f-component';


export class ViewModel extends FComponent {
  constructor(params, element) {
    super(params, element);

    this.show = params.show;
    const delay = params.delay || 3000;
    this.text = params.text || '';
    // html — разметка сообщения (например, с выделением жирным); имеет приоритет над text
    this.html = params.html || '';
    // default — справа внизу; warning — по центру, красный;
    // success / error — по центру, зелёный / красный (всплывающие сообщения по макету UI-кита)
    this.mode = params.mode || 'default';

    this.modeClass = ko.pureComputed(() => 'fc-toast--' + ko.unwrap(this.mode));

    let timer = null;
    this.subscriptions.push(
      this.show.subscribe((v) => {
        clearTimeout(timer);
        if (v) {
          timer = setTimeout(() => {
            if (!this.show()) {
              return;
            }
            this.show(false);
          }, delay);
        }
      })
    );
    this.disposeCallbacks.push(() => clearTimeout(timer));
  }
}
